module.exports = __webpack_public_path__ + "static/media/law.32d30d19.jpg";